var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.54 21.94C10.31 21.94 10.09 21.84 9.94003 21.64L8.93002 20.29C8.72002 20.01 8.44005 19.85 8.14005 19.83C7.84004 19.81 7.54002 19.95 7.30002 20.2C5.85002 21.75 4.75003 21.62 4.22003 21.42C3.68003 21.21 2.77002 20.52 2.77002 18.3V7.04001C2.77002 2.60001 4.05002 1.25 8.24002 1.25H15.79C19.98 1.25 21.26 2.60001 21.26 7.04001V11.3C21.26 11.71 20.92 12.05 20.51 12.05C20.1 12.05 19.76 11.71 19.76 11.3V7.04001C19.76 3.43001 19.13 2.75 15.79 2.75H8.24002C4.90002 2.75 4.27002 3.43001 4.27002 7.04001V18.3C4.27002 19.35 4.53002 19.93 4.77002 20.02C4.95002 20.09 5.44004 19.99 6.20004 19.18C6.75004 18.6 7.47003 18.29 8.22003 18.33C8.96003 18.37 9.66004 18.76 10.13 19.39L11.15 20.74C11.4 21.07 11.33 21.54 11 21.79C10.85 21.9 10.69 21.94 10.54 21.94Z",
    fill: "#3E485B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.75H8C7.59 7.75 7.25 7.41 7.25 7C7.25 6.59 7.59 6.25 8 6.25H16C16.41 6.25 16.75 6.59 16.75 7C16.75 7.41 16.41 7.75 16 7.75Z",
    fill: "#95A3B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.75H9C8.59 11.75 8.25 11.41 8.25 11C8.25 10.59 8.59 10.25 9 10.25H15C15.41 10.25 15.75 10.59 15.75 11C15.75 11.41 15.41 11.75 15 11.75Z",
    fill: "#3E485B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 21.54C19.6529 21.54 19.2129 21.09 19.2129 20.54C19.2129 19.99 19.6629 19.54 20.2129 19.54C20.7629 19.54 21.2129 19.99 21.2129 20.54C21.2129 21.09 20.7629 21.54 20.2129 21.54Z",
    fill: "#95A3B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3525 17.4902C14.7925 17.4902 14.3525 17.0402 14.3525 16.4902C14.3525 15.9402 14.8025 15.4902 15.3525 15.4902C15.9025 15.4902 16.3525 15.9402 16.3525 16.4902C16.3525 17.0402 15.9025 17.4902 15.3525 17.4902Z",
    fill: "#95A3B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0527 21.9399C14.8627 21.9399 14.6727 21.8699 14.5227 21.7199C14.2327 21.4299 14.2327 20.9499 14.5227 20.6599L19.9827 15.1999C20.2727 14.9099 20.7527 14.9099 21.0427 15.1999C21.3327 15.4899 21.3327 15.9699 21.0427 16.2599L15.5827 21.7199C15.4427 21.8599 15.2427 21.9399 15.0527 21.9399Z",
    fill: "#95A3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptSearch);
export default __webpack_public_path__ + "static/media/receipt-search.6c7a1a45675dd5260312959a4eeeb365.svg";
export { ForwardRef as ReactComponent };